import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getPaymentMethod } from '../../../actions/user.actions';
import { selectUser } from '../../../reducers/user.selectors';
import useAction from '../../../utils/useAction';
import AccountPage from '../../AccountPage';

const PersonalDetailsAccountSection: React.FC = () => {
  const user = useSelector(selectUser);
  const getPaymentMethodAction = useAction(getPaymentMethod);

  useEffect(() => {
    getPaymentMethodAction();
  }, [user?.id]);

  return <AccountPage />;
};

export default PersonalDetailsAccountSection;
